import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container-narrow columns" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "mt-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "is-flex is-align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title is-5 mb-0" }, " Previous publications ")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "panel container-narrow"
}
const _hoisted_8 = { class: "is-flex-grow-1 is-flex gap-1" }
const _hoisted_9 = {
  key: 0,
  class: "tag"
}
const _hoisted_10 = {
  key: 1,
  class: "tag"
}
const _hoisted_11 = {
  key: 1,
  class: "has-text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_job_form = _resolveComponent("job-form")!
  const _component_external_term = _resolveComponent("external-term")!
  const _component_job_item = _resolveComponent("job-item")!
  const _component_loading_block = _resolveComponent("loading-block")!

  return (_ctx.jobCollection)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.jobCollection.actions.createPublish)
              ? (_openBlock(), _createBlock(_component_job_form, {
                  key: 0,
                  operation: _ctx.jobCollection.actions.createPublish,
                  class: "box"
                }, null, 8, ["operation"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.jobCollection.actions.createUnlist)
              ? (_openBlock(), _createBlock(_component_job_form, {
                  key: 0,
                  operation: _ctx.jobCollection.actions.createUnlist,
                  confirm: true,
                  "confirmation-message": "Are you sure you want to unlist this cube? This operation is not reversible.",
                  "submit-button-variant": "danger",
                  class: "box"
                }, null, 8, ["operation"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.jobs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job) => {
                  return (_openBlock(), _createBlock(_component_job_item, {
                    key: job.clientPath,
                    job: job,
                    "detail-view": "PublicationJob",
                    class: "panel-block"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        (job.revision)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Version " + _toDisplayString(job.revision), 1))
                          : _createCommentVNode("", true),
                        (job.status)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                              _createVNode(_component_external_term, {
                                resource: job.status
                              }, null, 8, ["resource"])
                            ]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(job.publishedTo, (publication, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: index,
                            class: "tag"
                          }, [
                            _createVNode(_component_external_term, { resource: publication }, null, 8, ["resource"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["job"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, " No jobs yet "))
        ])
      ]))
    : (_openBlock(), _createBlock(_component_loading_block, { key: 1 }))
}